export const userRole = {
  CHALLENGE_ADMIN: "challengeAdmin",
  LICENCE_ADMIN: "licenseeAdmin",
  SUPER_ADMIN: "superAdmin",
  EVALUATOR: "evaluator",
  JUDGE: "judge",
};
